import {
    rus2eng,
    eng2rus
} from "./main";

export function highlightSubstring(str, subStr, type) {
    switch (type) {
        case undefined:
            return highlightString(str, subStr);
        case "currency":
            return highlightCurrency(str, subStr);
    }
}

const BLACK = "#000000";
const WHITE = "#FFFFFF";
export function getColorTextFor(backgroundColor) {
    if ( backgroundColor === "transparent" ) {
        return BLACK;
    }
    if ( isDark(backgroundColor) ) {
        return WHITE;
    }
    return BLACK;
}

//
// Return true if color is dark, false otherwise.
// (C) 2008 Syronex / J.M. Rosengard
//
export function isDark(hexColor) {
    let color = parseInt(hexColor.substr(1), 16);
    return (color >>> 16)// R
        + ((color >>> 8) & 0x00ff)// G
        + (color & 0x0000ff) // B
        < 500;
}


function highlightCurrency(str, subStr) {
    subStr = subStr.replace(/[ .,]/g, "");
    const exp = subStr
        .split("")
        .reduce((acc, val) => acc += val + "[ .]*", "");
    const match = str.match(new RegExp(exp));

    return !match
        ? str
        : ""
                + str.slice(0, match.index)
                + "<span style=\"background-color: yellow\">"
                + str.slice(match.index, match.index + match[0].length)
                + "</span>"
                + str.slice(match.index + match[0].length);

}

function highlightString(str, subStr) {
    let subStrPos = -1;
    const ruSubStr = eng2rus(subStr);
    const ruSubStrPos = str
        .toLowerCase()
        .indexOf(ruSubStr.toLowerCase());

    const enSubStr = rus2eng(subStr);
    const enSubStrPos = str
        .toLowerCase()
        .indexOf(enSubStr.toLowerCase());

    if ( ruSubStrPos !== -1 ) {
        subStr = ruSubStr;
        subStrPos = ruSubStrPos;
    } else if ( enSubStrPos !== -1 ) {
        subStr = enSubStr;
        subStrPos = enSubStrPos;
    }

    return subStrPos === -1
        ? str
        : ""
                + str.slice(0, subStrPos)
                + "<span style=\"background-color: yellow\">"
                + str.slice(subStrPos, subStrPos + subStr.length)
                + "</span>"
                + str.slice(subStrPos + subStr.length);
}
